import { useEffect, useState } from "react";
import { cubejsApi } from "../../../Cubejs/CubejsApiWrapper";
import { SoftTagFormula } from "../../softTag/SoftTagFormula";
import { useSelector } from "react-redux";

const GraphDataMqtt = ({
  selectTagData,
  setGraphRealTimeData,
  selectTimeRange,
  dataArray, // This is combinedData from parent
}) => {
  const { selectTimeZoneProfile } = useSelector((state) => state.userState);

  const getTagTime = (timeZone) => {
    const now = new Date().toLocaleTimeString("en-US", {
      timeZone: timeZone || "UTC",
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return `${now}`;
  };
  

  useEffect(() => {
    if (!selectTagData || !selectTagData.tag_config_data || !selectTagData.tag_config_data[0]) {
      return;
    }

    // Only proceed if selectTimeRange is 'live' for this effect
    if (selectTimeRange === "live") {
      const selectedTagConfig = selectTagData.tag_config_data[0];
      const findDvTag = selectedTagConfig.device_tag;
      const findSoftTag = selectedTagConfig.is_soft_tag;
      const findSoftTagFormula = selectedTagConfig.soft_tag_id__formula;

      let latestTagValue;

      if (findSoftTag && findSoftTagFormula) {
        // Calculate soft tag value
        const softTagResult = SoftTagFormula(findSoftTagFormula, dataArray);
        if (softTagResult?.softTagNotGetTag) { // Assuming this condition means a valid calculation
          latestTagValue = softTagResult.value;
        } else {
          // Handle cases where soft tag formula might not yield a value
          latestTagValue = null;
        }
      } else if (findDvTag) {
        // Get value directly from combinedData for regular tags
        latestTagValue = dataArray[findDvTag];
      }

      // Update graphRealTimeData only if a valid value is found
      if (latestTagValue !== undefined && latestTagValue !== null) {
        setGraphRealTimeData((prev) => {
          let oldData = [...prev];
          const currentTime = getTagTime(selectTimeZoneProfile); // Get current time here

          // Remove the old checks that prevent updates
          // if (oldData.length && oldData[oldData.length - 1]?.tagTime === currentTime) {
          //     return oldData;
          // }

          if (oldData.length >= process.env.REACT_APP_GRAPH_LENGTH) {
            oldData.shift(); // Remove oldest entry if exceeds MAX_LENGTH
          }

          const newData = [...oldData, { tagValue: parseFloat(latestTagValue), tagTime: currentTime }];
          return newData;
        });
      }
    }
  }, [dataArray, selectTagData, selectTimeRange, setGraphRealTimeData, selectTimeZoneProfile]); // Add dataArray to dependencies

  // Existing useEffect for non-live data (1min, 5min, 15min)
  useEffect(() => {
    if (!selectTagData.tag_config_data || !selectTagData.tag_config_data[0]) {
      return;
    }

    const executeCubeQuery = async () => {
      try {
        const tagId = selectTagData.tag_config_data[0].id.toString();
        const timeZone = selectTimeZoneProfile || 'UTC';
        const currentTime = new Date().toLocaleTimeString("en-US", {
          timeZone: timeZone,
          hour12: false,
        });

        const chartGraph = await cubejsApi.load({
          dimensions: ["DeviceConfigurationTagconfiguration.latestValue"],
          limit: 1,
          filters: [
            {
              member: "DeviceConfigurationTagconfiguration.tagid",
              operator: "equals",
              values: [tagId],
            },
          ],
        });

        const tagValue = parseFloat(
          chartGraph.tablePivot().length
            ? chartGraph.tablePivot()[0][
                "DeviceConfigurationTagconfiguration.latestValue"
              ] || 0
            : 0
        );

        setGraphRealTimeData((prev) => {
          const indexCopy = [...prev, { tagValue, tagTime: currentTime }];
          if (indexCopy.length >= process.env.REACT_APP_GRAPH_LENGTH) {
            indexCopy.shift();
          }
          return indexCopy;
        });
      } catch (error) {
        console.error("Cube query error:", error);
      }
    };

    let interval = null;
    if (selectTimeRange === "1min") {
      executeCubeQuery(); // Initial fetch
      interval = setInterval(executeCubeQuery, 60000);
    } else if (selectTimeRange === "5min") {
      executeCubeQuery(); // Initial fetch
      interval = setInterval(executeCubeQuery, 300000);
    } else if (selectTimeRange === "15min") {
      executeCubeQuery(); // Initial fetch
      interval = setInterval(executeCubeQuery, 900000);
    } else if (selectTimeRange === "live") {
      // Clear interval if switching back to live, as live updates are handled by the other useEffect
      clearInterval(interval);
    }


    return () => {
      clearInterval(interval);
    };
  }, [
    selectTagData,
    selectTimeRange,
    setGraphRealTimeData,
    selectTimeZoneProfile,
  ]);

  return null;
};

export default GraphDataMqtt;